import { useState } from "react";
import { DEFAULT_WEIGHTS } from "../lib/criteria.js";

// Korte prioriteiten-wizard die de criteria-gewichten zet.
// Maakt de score persoonlijk zonder dat je 15 sliders hoeft te begrijpen.
const QUESTIONS = [
  {
    id: "focus", q: "Wat weegt nu het zwaarst?",
    opts: [
      { label: "🏡 Het gezin", w: { youngFamilies:10, montessori:9, forestSchool:9, services:8 } },
      { label: "🌡 Klimaat", w: { climate:10, dryness:10, sunshine:10 } },
      { label: "🌿 Natuur & zelfvoorziening", w: { natureAccess:10, foodAutonomy:10, tranquility:9, culturalAuthenticity:9 } },
      { label: "🏄 Surf & lifestyle", w: { surf:10, wellness:9, coffee:8 } },
    ],
  },
  {
    id: "climate", q: "Hoe belangrijk is droog & zonnig?",
    opts: [
      { label: "Heel belangrijk", w: { dryness:10, sunshine:10 } },
      { label: "Best wel",        w: { dryness:8, sunshine:8 } },
      { label: "Minder",          w: { dryness:5, sunshine:5 } },
    ],
  },
  {
    id: "vibe", q: "Liever rust of reuring?",
    opts: [
      { label: "🔇 Rust", w: { tranquility:10, culturalAuthenticity:9, coffee:3 } },
      { label: "☕ Reuring & community", w: { coffee:9, wellness:8, tranquility:5 } },
    ],
  },
  {
    id: "farm", q: "Wil je land bewerken / zelfvoorzienend zijn?",
    opts: [
      { label: "Ja, essentieel", w: { foodAutonomy:10, natureAccess:9, water:10 } },
      { label: "Leuk maar niet must", w: { foodAutonomy:6 } },
    ],
  },
  {
    id: "remote", q: "Werken jullie (deels) op afstand?",
    opts: [
      { label: "Ja, snel internet is must", w: { internet:10 } },
      { label: "Soms", w: { internet:7 } },
      { label: "Nee", w: { internet:4 } },
    ],
  },
  {
    id: "water", q: "Hoe belangrijk is waterzekerheid?",
    opts: [
      { label: "Heel — irrigatie/homestead", w: { water:10 } },
      { label: "Belangrijk", w: { water:7 } },
      { label: "Minder", w: { water:4 } },
    ],
  },
];

export function PriorityWizard({ onApply, onClose }) {
  const [answers, setAnswers] = useState({});

  const pick = (qid, idx) => setAnswers(a => ({ ...a, [qid]: idx }));

  const apply = () => {
    // Niet overschrijven op vraagvolgorde: neem per criterium de hoogste
    // gewenste weging over alle gekozen antwoorden (tegenstrijdige antwoorden
    // laten het sterkste signaal staan i.p.v. het laatste).
    const w = { ...DEFAULT_WEIGHTS };
    for (const q of QUESTIONS) {
      const idx = answers[q.id];
      if (idx == null) continue;
      for (const [k, v] of Object.entries(q.opts[idx].w)) {
        w[k] = Math.max(w[k] ?? 0, v);
      }
    }
    try { localStorage.setItem("onboarded", "1"); } catch {}
    onApply(w);
    onClose();
  };

  const skip = () => { try { localStorage.setItem("onboarded", "1"); } catch {}; onClose(); };
  const answeredCount = Object.keys(answers).length;

  return (
    <div onClick={e => e.target === e.currentTarget && skip()}
      style={{ position:"fixed", inset:0, zIndex:700, background:"rgba(0,0,0,.5)",
               display:"flex", alignItems:"flex-end", justifyContent:"center" }}>
      <div style={{ background:"#fff", width:"100%", maxWidth:560, maxHeight:"90vh", overflowY:"auto",
                    borderRadius:"18px 18px 0 0", padding:"20px 18px calc(20px + env(safe-area-inset-bottom,0px))" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:6 }}>
          <h2 style={{ margin:0, fontSize:19, fontWeight:700 }}>Stel je prioriteiten in</h2>
          <button onClick={skip} aria-label="Overslaan"
            style={{ background:"none", border:"none", fontSize:22, color:"#888", cursor:"pointer" }}>×</button>
        </div>
        <p style={{ margin:"0 0 14px", fontSize:13, color:"#777" }}>
          We stemmen de scores af op wat voor jullie telt. Je kunt dit later altijd aanpassen.
        </p>

        {QUESTIONS.map(q => (
          <div key={q.id} style={{ marginBottom:18 }}>
            <div style={{ fontSize:14, fontWeight:600, marginBottom:8 }}>{q.q}</div>
            <div style={{ display:"flex", flexWrap:"wrap", gap:8 }}>
              {q.opts.map((o, i) => {
                const on = answers[q.id] === i;
                return (
                  <button key={i} onClick={() => pick(q.id, i)}
                    style={{ padding:"9px 14px", borderRadius:22, fontSize:13, fontWeight:600, cursor:"pointer",
                             border: on ? "2px solid #d4537e" : "1px solid #ddd",
                             background: on ? "#fdeef3" : "#fff", color: on ? "#b8385f" : "#444" }}>
                    {o.label}
                  </button>
                );
              })}
            </div>
          </div>
        ))}

        <button onClick={apply}
          style={{ width:"100%", height:48, marginTop:6, border:"none", borderRadius:24,
                   background:"#d4537e", color:"#fff", fontSize:15, fontWeight:700, cursor:"pointer" }}>
          {answeredCount ? "Toon mijn matches" : "Sla over en toon alles"}
        </button>
      </div>
    </div>
  );
}
